import type { PositionChangeData, WaypointPosition } from './types';

/**
 * Builds the position change data object.
 * For horizontal mode, waypointTop/Bottom and viewportTop/Bottom represent left/right values.
 * Uses entry.rootBounds for accurate viewport bounds relative to the scroll container.
 */
export function buildPositionChangeData(params: {
	entry: IntersectionObserverEntry;
	currentPosition: WaypointPosition;
	previousPosition: WaypointPosition | undefined;
	horizontal?: boolean;
}): PositionChangeData {
	const { entry, currentPosition, previousPosition, horizontal = false } = params;
	const { boundingClientRect: rect, rootBounds } = entry;

	if (horizontal) {
		return {
			currentPosition,
			previousPosition,
			event: null,
			waypointTop: rect.left,
			waypointBottom: rect.right,
			viewportTop: rootBounds?.left ?? 0,
			viewportBottom: rootBounds?.right ?? window.innerWidth,
		};
	}

	return {
		currentPosition,
		previousPosition,
		event: null,
		waypointTop: rect.top,
		waypointBottom: rect.bottom,
		viewportTop: rootBounds?.top ?? 0,
		viewportBottom: rootBounds?.bottom ?? window.innerHeight,
	};
}
